<template>
  <!-- 医美 11-12 新激励排行榜 -->
  <div class="ranking">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :error.sync="error" error-text="请求失败，点击重新加载" :immediate-check="false">
      <div>
        <!-- banner -->
        <img class="banner" :src="`${currentJobTabObj.url}20260305/${currentJobTabObj.bannerImg}.png`" alt="banner" />
        <span :class="['rule', ` rule${currentJobTab}`]" @click="toRule">
          活动规则
        </span>
        <!-- 奖品 -->
        <div class="reward-box">
          <div v-if="currentJobTab === '4'">
            <div class="bear-palm">
              <p>获奖奖品</p>
              <div class="reward-bot">
                <span>激励对象：</span>
                <p>秀可儿销售岗 (美学院长、美学专家)</p>
              </div>
              <div class="reward-bot">
                <span>激励条件：每双周根据上一个双周新品销售累积销售人数进行 PK，每双周产生 1 位销冠</span>
              </div>
              <div class="prizeWrapper">
                <div class="prizeRank">
                  <div v-if="currentGroupTab === '第一组'"><span>第一名获得：388 现金</span></div>
                  <div v-else-if="currentGroupTab === '第二组'"><span>第一名获得：288 现金</span></div>
                  <div v-else-if="currentGroupTab === '第三组'"><span>第一名获得：188 现金</span></div>
                  <div v-else-if="currentGroupTab === '第四组'"><span>第一名获得：88 现金</span></div>
                  <div v-else><span>数据错误</span></div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="currentJobTab === '5'">
            <div class="bear-palm">
              <p>获奖奖品</p>
              <div class="reward-bot">
                <span>激励对象：</span>
                <p>秀可儿销售岗 (美学院长、美学专家)</p>
              </div>
              <div class="reward-bot">
                <p>激励条件：每月度根据单月新品销售额累积销售额进行 PK，每月度产生 1 位销冠</p>
              </div>
              <div :class="[
                'prizeWrapper',
                {
                  'flex-between': currentJobTab == 1,
                  'flex-around': currentJobTab == 2,
                },
              ]">
                <div class="prizeRank">
                  <div class="prizeRank">
                    <div v-if="currentGroupTab === '第一组'"><span>第一名获得：888 现金</span></div>
                    <div v-else-if="currentGroupTab === '第二组'"><span>第一名获得：688 现金</span></div>
                    <div v-else-if="currentGroupTab === '第三组'"><span>第一名获得：388 现金</span></div>
                    <div v-else-if="currentGroupTab === '第四组'"><span>第一名获得：188 现金</span></div>
                    <div v-else><span>数据错误</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="currentJobTab === '6'">
            <div class="bear-palm">
              <p>获奖奖品</p>
              <div class="reward-bot">
                <span>激励对象：</span>
                <p>秀可儿销售岗 (美学院长、美学专家)</p>
              </div>
              <div class="reward-bot">
                <p>激励条件：各销售岗综合业绩目标 100% 达标后进行 PK，排名前三名销售岗获奖</p>
              </div>
              <div class="prizeWrapper">
                <div class="prizeRank">
                  <div v-if="currentGroupTab === '第一组'">
                    <div>第 1 名获得：4000 元现金</div>
                    <div>第 2 名获得：3000 元现金</div>
                    <div>第 3 名获得：2000 元现金</div>
                  </div>
                  <div v-else-if="currentGroupTab === '第二组'">
                    <div>第 1 名获得：3000 元现金</div>
                    <div>第 2 名获得：2500 元现金</div>
                    <div>第 3 名获得：2000 元现金</div>
                  </div>
                  <div v-else-if="currentGroupTab === '第三组'">
                    <div>第 1 名获得：2000 现金</div>
                    <div>第 2 名获得：1500 现金</div>
                    <div>第 3 名获得：1000 现金</div>
                  </div>
                  <div v-else-if="currentGroupTab === '第四组'">
                    <div>第 1 名获得：1000 现金</div>
                    <div>第 2 名获得：800 现金</div>
                    <div>第 3 名获得：500 现金</div>
                  </div>
                  <div v-else><span>数据错误</span></div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="currentJobTab == 7 || currentJobTab == 8">
            <div class="bear-palm">
              <p>获奖奖品</p>
              <div class="reward-bot">
                <span>激励对象：</span>
                <p>秀可儿主诊助理 (1-3 级美学顾问)</p>
              </div>
              <div class="reward-bot">
                <p>激励条件：各主诊助理单月非 0 消费人数目标 100% 达标后进行 PK，排名前三名助理获奖</p>
              </div>
              <div class="prizeWrapper">
                <div class="prizeRank">
                  <div v-if="currentGroupTab === '第一组'">
                    <div>第 1 名获得：1500 元现金</div>
                    <div>第 2 名获得：1200 元现金</div>
                    <div>第 3 名获得：1000 元现金</div>
                  </div>
                  <div v-else-if="currentGroupTab === '第二组'">
                    <div>第 1 名获得：800 元现金</div>
                    <div>第 2 名获得：500 元现金</div>
                    <div>第 3 名获得：300 元现金</div>
                  </div>
                  <div v-else-if="currentGroupTab === '第三组'">
                    <div>第 1 名获得：500 现金</div>
                    <div>第 2 名获得：300 现金</div>
                    <div>第 3 名获得：300 现金</div>
                  </div>
                  <div v-else><span>数据错误</span></div>
                </div>
              </div>
            </div>
          </div>
          <p class="update-time">数据更新时间 {{ updateTime }}</p>
        </div>
        <div class="bg-color"></div>
      </div>
      <div class="ranking-box">
        <div class="tabs-box">
          <div :class="['job-tabs', currentJobTab == 7 || currentJobTab == 8 ? 'flex-around' : '']">
            <div class="job-tab-item" v-for="(it, ind) in jobTabs" :key="ind" :class="{ 'on': currentJobTab == it.tabType }" @click="onJobTab(it)">
              {{ it.tabName }}
            </div>
          </div>
          <div class="job-tabs2 flex flex-around" v-if="currentJobTabObj?.rankingTabInfoList?.length > 0">
            <div class="job-tab-item" v-for="it in currentJobTabObj?.rankingTabInfoList" :key="it.id" :class="{ 'on': currentJobTab2 == it.tabType }" @click="onJobTab2(it)">
              {{ it.tabName }}
            </div>
          </div>
          <div class="group-tabs">
            <div class="group-tab-item" :class="{ 'on': currentGroupTab == it }" v-for="(it, i) in groupTabs" :key="i" @click="onGroupTab(it)">
              {{ it }}
            </div>
          </div>
        </div>
        <div class="ranking-list-box">
          <div class="myWrapper" v-if="myData">
            <RankingItem :currentJobTab="currentJobTab" isMe :list="[myData]" :currentGroupTab="currentGroupTab" />
          </div>
          <div class="ranking-list-item title">
            <div class="ranking-num">排名</div>
            <div class="ranking-name">{{ currentJobTabObj?.title1 }}</div>
            <div class="ranking-order">{{ currentJobTabObj?.title2 }}</div>
            <div class="ranking-bonus">{{ currentJobTabObj?.title3 }}</div>
          </div>
          <RankingItem :currentJobTab="currentJobTab" :list="list" :currentGroupTab="currentGroupTab" :dataInfo="dataInfo" />
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
  import request from '@/utils/request'
  import RankingItem from './rankingItem'
  import { debounce } from 'lodash'
  import { ActionSheet, Toast } from 'vant'

  export default {
    name: 'marYmRankList',
    components: {
      RankingItem,
      [ActionSheet.name]: ActionSheet,
    },
    data() {
      return {
        showRule: false, // 是否显示规则弹窗
        jobTabs: [], // 职位分类标签列表
        currentJobTab: '1',
        currentJobTabObj: {}, // 当前选中的职位分类对象
        jobTabs2: [], // 分类标签列表 2
        currentJobTab2: '', // 当前选中的分类 2
        currentJobTab2Obj: {},
        groupTabs: [], // 分组标签列表
        currentGroupTab: '第一组', // 当前选中的分组
        currentGroupTabObj: {},
        loading: false, // 是否正在加载
        currentMoldTab: '', // 当前选中第三层分组
        finished: false, // 是否加载完成
        list: [], // 排名列表数据
        page: 1, // 当前页码
        error: false, // 是否发生错误
        themeArr: [
          {
            url: 'https://staticwecom.beautyfarm.com.cn/',
            bannerImg: 'zzsz',
            title1: '主诊咨询',
            title2: '销售人数 ',
            title3: '奖励',
            ruleImg: 'ym1',
          },
          {
            url: 'https://staticwecom.beautyfarm.com.cn/',
            bannerImg: 'zzyd',
            title1: '主诊咨询',
            title2: '销售额 ',
            title3: '奖励',
            ruleImg: 'ym1',
          },
          {
            url: 'https://staticwecom.beautyfarm.com.cn/',
            bannerImg: 'zzsy',
            title1: '主诊咨询',
            title2: '综合目标达成率',
            title3: '奖励',
            ruleImg: 'ym1',
          },
          {
            url: 'https://staticwecom.beautyfarm.com.cn/',
            bannerImg: 'mxgw',
            title1: '美学顾问',
            title2: '客流目标达成率',
            title3: '奖励',
            ruleImg: 'ym2',
          },
        ],
        dataInfo: {}, // 后端整个详情
        myData: {}, // 我的个人数据
        updateTime: '', // 数据更新时间
      }
    },
    mounted() {
      this.getjobTabs()
    },
    methods: {
      // 优化：将 computed 返回函数改为普通方法，逻辑更清晰
      getGroupNoRewardAmtList(currentGroupTab) {
        if (!this.dataInfo || !this.dataInfo.groupNoRewardAmtObj) {
          return []
        }
        return this.dataInfo.groupNoRewardAmtObj.rewardAmtList || []
      },
      // 初始化数据，获取销售列表
      getDataList: debounce(async function () {
        if (this.finished) return
        Toast.loading({
          forbidClick: true,
          duration: 0,
        })
        try {
          const params = {
            groupNo: this.currentGroupTab,
            page: this.page,
            type: this.currentJobTab,
            typeTwo: this.currentJobTab2,
            limit: 10,
          }
          const { code, msg, data } = await request({
            url: '/ym/new-year/ranking/getRankingInfoPage',
            method: 'get',
            params,
          })
          if (code !== 0) {
            throw new Error(msg)
          }
          Toast.clear()
          // 对应 jobTabs 中的 dataInfo 赋值
          this.dataInfo = data
          this.myData = data.empRankingInfo
          this.updateTime = data.updateTime
          // 对赌激励取 cspPkList，销售纳新取 cspMmbList
          const list = data && data.rankingList
          if (this.page == 1) {
            this.list = list
          } else {
            this.list = this.list.concat(list)
          }
          this.page += 1
          this.loading = false

          if (list.length < 10) {
            this.finished = true
          }
        } catch (error) {
          this.loading = false
          this.error = true
          console.error(error)
        }
      }, 500),
      onLoad() {
        this.getDataList()
      },
      // 切换职位分类标签
      onJobTab(value) {
        // 优化：移除冗余赋值，直接使用 value
        this.currentJobTabObj = value
        this.currentJobTab = value.tabType || '1'
        // 二级分类默认选中第一个
        this.currentJobTab2 = this.currentJobTabObj?.rankingTabInfoList?.[0]?.tabType || ''
        this.currentJobTab2Obj = this.currentJobTabObj?.rankingTabInfoList?.[0] || {}
        // 分组默认选中第一个
        this.currentGroupTab = '第一组'
        this.page = 1
        this.finished = false
        this.error = false
        this.getGroupTab()
      },
      onJobTab2(value) {
        this.currentJobTab2 = value.tabType
        this.currentJobTab2Obj = value
        // 分组默认选中第一个
        this.currentGroupTab = '第一组'
        this.currentGroupTabObj = this.groupTabs[0]
        this.page = 1
        this.finished = false
        this.error = false
        this.getGroupTab()
      },

      // 切换分组标签
      onGroupTab(v) {
        if (this.currentGroupTab == v) return
        this.currentGroupTab = v
        this.currentGroupTabObj = v
        this.finished = false
        this.error = false
        this.page = 1
        this.getDataList()
      },
      toRule() {
        let currentJobTab = this.currentJobTab == '8' || this.currentJobTab == '7' ? '2' : '1'
        this.$router.push({
          path: '/marYmRankListRules',
          query: { currentJobTab: currentJobTab },
        })
      },
      // 获取职位分类标签
      async getjobTabs() {
        const { data } = await request({
          url: '/ranking/tab-info/getYmRankingTabInfoList',
          method: 'get',
        })
        // 重组数据，该处理应新建数据进去
        const newArr = data.map((item, index) => {

          if (item.tabType == '8' || item.tabType == '7') {
            const theme = this.themeArr[this.themeArr.length - 1] || {}
            return { ...item, ...theme }
          } else {
            // 增加安全判断，防止 themeArr 越界
            const theme = this.themeArr[index] || {}
            return { ...item, ...theme }
          }
          
        })
        this.jobTabs = newArr
        // 一级分类默认选中当前岗位，或者第一个
        this.currentJobTabObj =
          this.jobTabs.find((i) => i.isChecked == 1) || this.jobTabs[0]
        // 二级分类默认选中第一个
        this.currentJobTab = this.currentJobTabObj?.tabType || '1'
        this.currentJobTab2 =
          this.currentJobTabObj?.rankingTabInfoList?.[0]?.tabType || ''
        this.currentJobTab2Obj =
          this.currentJobTabObj?.rankingTabInfoList?.[0] || {}
        this.getGroupTab()
      },
      // 获取分组标签
      async getGroupTab() {
        const { data } = await request({
          url: '/ym/new-year/ranking/getGroupNoTab',
          method: 'get',
          params: { type: this.currentJobTab },
        })
        this.groupTabs = data && data.groupNoList && data.groupNoList.length > 0 ? data.groupNoList : [];
        // 默认选中第一组
        this.currentGroupTabObj = this.groupTabs[0]
        this.getDataList()
      },
    },
  }
</script>

<style lang='less' scoped>
  .ranking {
    position: relative;
    height: 100%;
    font-size: 28px;
    overflow-y: scroll;
    color: #333333;
    background-color: #fff;

    .flex-around {
      display: flex;
      justify-content: space-around;
    }

    .flex-between {
      display: flex;
      justify-content: space-between;
    }
  }

  .myWrapper {
    padding: 20px;
  }

  .banner {
    width: 100%;
    min-height: 464px;
    height: 464px;
  }

  .rule {
    position: absolute;
    width: 120px;
    top: 50px;
    right: 0;
    height: 61px;
    line-height: 61px;
    font-size: 26px;
    text-align: center;
    color: #ffffff;
    background: rgba(0, 0, 0, 0.5);
    border-top-left-radius: 31px;
    border-bottom-left-radius: 31px;
  }

  .reward-box {
    position: relative;
    width: 100%;
    margin-top: -94px;
    padding: 30px;
    text-align: center;
    background-color: #fff;
    border-radius: 40px;
    z-index: 9;

    .bear-palm {
      width: 100%;
      background: #eef8ff;
      border-radius: 50px;
      padding: 0 63px;
      font-size: 26px;
      color: #333333;
      padding-bottom: 45px;

      >p {
        width: 325px;
        height: 70px;
        background: #a3c8e2;
        border-radius: 0px 0px 40px 40px;
        margin: 0 auto;
        text-align: center;
        font-weight: bold;
        font-size: 36px;
        color: #ffffff;
        line-height: 70px;
        text-shadow: 1px 3px 0px rgba(60, 0, 94, 0.52);
        margin-bottom: 36px;
      }

      img {
        width: 100%;
      }

      .reward-bot {
        margin-bottom: 20px !important;
        display: flex;
        color: #333;
        font-size: 26px;
        text-align: left;

        p {
          text-align: left;
          margin: 0;
          padding: 0;
        }
      }

      .reward-content {
        margin-bottom: 20px !important;
        color: #333;
        font-size: 24px;
        text-align: left;

        span {
          color: #d41d16;
          font-size: 30px;
          font-weight: bold;
        }
      }

      .reward-tips {
        margin-top: 20px !important;
        color: #666666;
        font-size: 18px;
      }

      .prizeWrapper {
        margin-top: 40px;
        align-items: center;

        .prizeRank>div {
          margin-bottom: 10px;
          font-size: 30px;
          font-weight: bold;
          color: #d41d16;
        }

        .prizeRank>.prizeTitle {
          font-size: 26px;
          color: #333333;
        }

        img {
          width: 150px;
        }
      }
    }
  }

  .update-time {
    font-size: 24px;
    color: #999999;
    margin-top: 20px;
  }

  .ranking-box {
    overflow: hidden;
    background-color: #fff;
    border-radius: 40px 40px 0 0;
  }

  .tabs-box {
    padding: 0 30px;
  }

  .job-tabs {
    overflow-x: auto;
    margin: 40px 0 10px 0;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;

    >div {
      display: inline-flex;
      white-space: nowrap;
    }
  }

  .job-tabs2 {
    margin: 0 0 10px 0;
  }

  .group-tabs {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 50px;
    overflow-x: auto;
    white-space: nowrap;
  }

  .job-tab-item {
    color: #999999;
    font-size: 30px;
    margin: 10px 20px 40px 0;
    font-weight: 500;
    text-align: center;
    border-radius: 30px;
    position: relative;
    flex-shrink: 0;

    &.on {
      color: #333333;

      &::before {
        position: absolute;
        content: '';
        left: 50%;
        bottom: -15px;
        width: 40px;
        height: 6px;
        transform: translate(-50%);
        background-color: #333333;
        border-radius: 4px;
      }
    }
  }

  .group-tab-item {
    min-width: 22%;
    text-align: center;
    font-size: 26px;
    color: #333333;
    background-color: #e6e6e6;
    border-radius: 20px;
    padding: 3px 10px;
    margin-right: 23px;

    &.on {
      color: #333333;
      background-color: #83a8c2;
    }
  }

  .ranking-list-box {
    border-top: 2px solid #eeeeee;
  }

  .ranking-list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 30px 40px;
    border-bottom: 2px solid #eeeeee;

    &.title {
      padding-bottom: 0;
      border: none;
      color: #999999;
    }
  }

  .ranking-num {
    width: 60px;
    margin-right: 40px;

    >img {
      width: 50px;
      height: 60px;
    }
  }

  .ranking-name {
    display: flex;
    align-items: center;
    width: 240px;

    >.img {
      width: 60px;
      height: 60px;
      margin-right: 10px;
    }
  }

  .ranking-order {
    width: 200px;
    text-align: center;
  }

  .ranking-bonus {
    width: 140px;
    text-align: center;
  }

  .bg-color {
    height: 90px;
    margin: -30px 0;
    background-color: #96bdd9;
  }

  .arrivedWrapper {
    display: flex;
    box-sizing: border-box;
    padding: 40px 78px;
    justify-content: space-between;

    .title {
      font-size: 24px;
      color: #333333;
    }

    .countWraper {
      >.content {
        font-size: 46px;
        color: #d62c18;
        font-weight: 500;

        span {
          font-size: 30px;
          font-weight: 500;
        }
      }

      >.content.isReach {
        color: #0072ff;
      }

      >.title {
        margin-bottom: 38px;
      }
    }

    .saleWrapper {
      >.content {
        font-size: 46px;
        color: #0072ff;
        font-weight: 500;
      }

      >.title {
        margin-bottom: 38px;
      }
    }
  }
</style>
<style lang="less">
  .ranking {
    .van-popup {
      overflow-y: visible;
    }

    .van-image__error {
      background-color: #a1a1a1;
    }

    .van-list__finished-text,
    .van-list__loading,
    .van-list__error-text {
      margin-top: -2px;
      background-color: #fff;
    }
  }
</style>